module.exports = __webpack_public_path__ + "img/10.bc3fe3e5.jpg";